export const indicadoresJudicialConfig = [
    { key: "sinAsignar", text: "Cantidad sin asignar", icon: "pending_actions" },
    { key: "montoSinAsignar", text: "Total sin asignar", icon: "inventory" },
    { key: "asignadosHoy", text: "Asignados del día", icon: "content_paste_off" },
    { key: "match100", text: "Coincidencia 100%", icon: "pending_actions" },
    { key: "matchMenor100", text: "Coincidencia < 100%", icon: "inventory" },
    { key: "asignados", text: "Total asignados", icon: "content_paste_off" }
];
